<script lang="ts">
  const currentYear = new Date().getFullYear();
</script>

<footer class="footer">
  <div class="footer-container">
    <div class="footer-content">
      <div class="footer-section">
        <h3>🎰 SpinWheel Pro</h3>
        <p>The #1 daily spin wheel game with real cash prizes and rewards. Join thousands of winners today!</p>
        <div class="social-links">
          <a href="#" aria-label="Facebook">📘</a>
          <a href="#" aria-label="Twitter">🐦</a>
          <a href="#" aria-label="Instagram">📷</a>
          <a href="#" aria-label="YouTube">📺</a>
        </div>
      </div>
      
      <div class="footer-section">
        <h4>Quick Links</h4>
        <ul>
          <li><a href="#wheel-section">Play Now</a></li>
          <li><a href="#features">Features</a></li>
          <li><a href="#how-it-works">How It Works</a></li>
          <li><a href="#faq">FAQ</a></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h4>Legal</h4>
        <ul>
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
          <li><a href="/disclaimer">Disclaimer</a></li>
          <li><a href="/cookies">Cookie Policy</a></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h4>Contact</h4>
        <ul>
          <li>📧 support@spinwheelpro.com</li>
          <li>💬 Live Chat Available</li>
          <li>⏰ 24/7 Support</li>
        </ul>
      </div>
    </div>
    
    <div class="footer-bottom">
      <p>&copy; {currentYear} SpinWheel Pro. All rights reserved.</p>
      <p class="disclaimer">This is a promotional game. No purchase necessary. Must be 18+ to play.</p>
    </div>
  </div>
</footer>

<style>
  .footer {
    background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
    color: white;
    padding: 60px 20px 30px;
    margin-top: 60px;
  }
  
  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .footer-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;
    margin-bottom: 40px;
  }
  
  .footer-section h3 {
    font-size: 1.5rem;
    margin-bottom: 15px;
    color: #FFD700;
  }
  
  .footer-section h4 {
    font-size: 1.2rem;
    margin-bottom: 15px;
    color: #FFD700;
  }
  
  .footer-section p {
    line-height: 1.8;
    opacity: 0.9;
  }
  
  .footer-section ul {
    list-style: none;
    padding: 0;
  }
  
  .footer-section ul li {
    margin-bottom: 10px;
  }
  
  .footer-section a {
    color: white;
    text-decoration: none;
    opacity: 0.8;
    transition: all 0.3s ease;
  }
  
  .footer-section a:hover {
    opacity: 1;
    color: #FFD700;
    padding-left: 5px;
  }
  
  .social-links {
    display: flex;
    gap: 15px;
    margin-top: 20px;
  }
  
  .social-links a {
    font-size: 1.8rem;
    transition: transform 0.3s ease;
  }
  
  .social-links a:hover {
    transform: scale(1.2);
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255,255,255,0.2);
    padding-top: 30px;
    text-align: center;
  }
  
  .footer-bottom p {
    margin-bottom: 10px;
    opacity: 0.8;
  }
  
  .disclaimer {
    font-size: 0.85rem;
    color: #bdc3c7;
  }
  
  @media (max-width: 768px) {
    .footer {
      padding: 40px 15px 20px;
    }
    
    .footer-content {
      gap: 30px;
    }
  }
</style>
